import { CommonModule } from '@angular/common';
import {
    Component,
    EventEmitter,
    Input,
    Output,
    ViewEncapsulation,
} from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';
import { SlickCarouselModule } from 'ngx-slick-carousel';
import {
    trigger,
    state,
    style,
    animate,
    transition,
} from '@angular/animations';

@Component({
    selector: 'app-campaigns-section',
    standalone: true,
    encapsulation: ViewEncapsulation.None,
    imports: [
        TranslateModule,
        CommonModule,
        MatIconModule,
        SlickCarouselModule,
    ],
    animations: [
        trigger('fadeInOut', [
            state(
                'void',
                style({
                    opacity: 0,
                }),
            ),
            transition('void => *', animate(1000)),
            transition('* => void', animate(0)),
        ]),
        trigger('fadeInOut2', [
            state(
                'void',
                style({
                    opacity: 0,
                }),
            ),
            transition('void => *', animate(1000)),
            transition('* => void', animate(800)),
        ]),
    ],
    templateUrl: './campaigns-section.component.html',
    styleUrl: './campaigns-section.component.scss',
})
export class CampaignsSectionComponent {
    // Input data
    @Input() campaignData: any = [];
    @Input() partnershipData: any = [];
    @Output() campDetails: any = new EventEmitter<any>();
    @Output() openDialog: any = new EventEmitter<any>();
    navCount: number = 0;
    navCountP: number = 0;
    currentSlide: number = 0;
    toogle: boolean = false;
    toggleP: boolean = false;
    showMoreCampaignsStatus: boolean = false;
    showMorePartnershipsStatus: boolean = false;

    // Pagination properties
    itemsPerPage: number = 4;
    currentPage: number = 1;
    displayedCampaigns: any[] = [];

    // Slick carousel configuration
    slideConfig = {
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: false,
        autoplay: true,
        autoplaySpeed: 5000,
        prevArrow:
            '<button class="slick-prev"><img src="/assets/images/icons/arrow-left.svg" alt="Previous" style="width: 60%; filter: brightness(0) saturate(100%) invert(27%) sepia(51%) saturate(2878%) hue-rotate(213deg) brightness(104%) contrast(97%);" /></button>',
        nextArrow:
            '<button class="slick-next"><img src="/assets/images/icons/arrow-right.svg" alt="Next" style="width: 60%; filter: brightness(0) saturate(100%) invert(27%) sepia(51%) saturate(2878%) hue-rotate(213deg) brightness(104%) contrast(97%);" /></button>',
    };

    ngOnInit() {
        this.updateDisplayedCampaigns();
    }

    ngOnChanges() {
        this.updateDisplayedCampaigns();
    }

    updateDisplayedCampaigns() {
        const startIndex = 0;
        const endIndex = this.currentPage * this.itemsPerPage;
        this.displayedCampaigns = this.campaignData.slice(startIndex, endIndex);
    }

    slideTabPrevious() {
        this.navCount--;
        this.toogle = !this.toogle;
    }

    slideTabNext() {
        this.navCount++;
        this.toogle = !this.toogle;
    }

    slideTabPreviousP() {
        this.navCountP--;
        this.toggleP = !this.toggleP;
    }

    slideTabNextP() {
        this.navCountP++;
        this.toggleP = !this.toggleP;
    }

    afterChange(e) {
        this.currentSlide = e.currentSlide;
    }

    beforeChange(e) {
        this.currentSlide = e.currentSlide;
    }

    showMoreCampaigns() {
        if (this.currentPage * this.itemsPerPage < this.campaignData.length) {
            this.currentPage++;
            this.updateDisplayedCampaigns();
        }
    }

    campaignDetails(campaign: any) {
        this.campDetails.emit(campaign);
    }

    showMorePartnerships() {
        this.showMorePartnershipsStatus = true;
    }

    showLessPartnerships() {
        this.showMorePartnershipsStatus = false;
        document.getElementById('desktopPartnership').scrollIntoView();
    }

    emitDialog(data: any) {
        this.openDialog.emit(data);
    }

    removeHtmlTags(text: string) {
        const doc = new DOMParser().parseFromString(text, 'text/html');
        return doc.body.textContent || '';
    }

    truncate(str: string, length: number): string {
        str = str || ''; // provide default value manually
        return str.length > length ? str.slice(0, length) : str;
    }
}
